import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_NURSE_VOICE_PER_OT_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASES_PER_OT_RESPONSE } from "../types/ResponseTypes";

async function getVoiceNoteLoggedPerCaseByNurse(
  tenantId?: string,
  hospitalId?: string,
  queryString?: string
): Promise<GET_CASES_PER_OT_RESPONSE> {
  const baseUrl = "analytics/nurse-voice-notes";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetVoiceNoteLoggedPerCaseByNurseQuery(
  tenantId?: string,
  hospitalId?: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_NURSE_VOICE_PER_OT_QUERY_KEY, queryString, hospitalId],
    queryFn: () =>
      getVoiceNoteLoggedPerCaseByNurse(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
    enabled: !!tenantId && !!hospitalId,
  });
}
